import React, { useState } from "react";
import styled from 'styled-components';
import PrintComponent from "../../Printing/OutsideServiceFormPrint"; // Assuming PrintComponent is in a separate file
import TextareaAutosize from 'react-textarea-autosize';
import { Datepick } from "../../utilities/Shared";
// Reusing styled components from PrintComponent for consistency
export const Wrapper = styled.div`
  padding: 20px;
  font-size: .8rem;
  font-weight: bold;
  text-transform: capitalize;
`;

export const Input = styled.input`
  position: ${props => props.position || "relative"};
  width: ${props => props.width || "90%"};
  padding: ${props => props.padding || "5px 3px 0px 3px"};
  max-width: ${props => props.maxWidth || "100%"};
  margin: ${props => props.margin || "0px 0px 0px 0px"};
  height: ${props => props.height || ""};
  font-size: ${props => props.fontSize || ".8rem"};
  text-align: ${props => props.textalign || "center"};
  font-weight: ${props => props.fontWeight || "bold"};
  outline: none;
  border: none;
  border-bottom: 1px solid grey;
  border-radius: 5px;
  :focus {
    border: 2px solid var(--plsGreen);
  }
`;

export const Flexed = styled.div`
  width: ${props => props.width || "100%"};
  display: flex;
  text-align: ${props => props.textAlign || ""};
  justify-content: ${props => props.justifycontent || "flex-end"};
  align-items: ${props => props.alignItems || "flex-start"};
  position: ${props => props.position || "relative"};
  padding: ${props => props.padding || "3px 0px"};
  bottom: ${props => props.bottom || ""};
  font-size: ${props => props.fontSize || ""};
  margin: ${props => props.margin || ""};
  border-bottom: ${props => props.borderBottom || ""};
`;

export const Flex = styled.div`
  width: ${props => props.width || "100%"};
  position: ${props => props.position || "relative"};
  flex: ${props => props.flex || "1"};
  white-space: ${props => props.whiteSpace || "nowrap"};
  border-bottom: ${props => props.border ? "1px solid black" : ""};
  text-align: ${props => props.textAlign || "left"};
  padding: ${props => props.padding || "0"};
  font-size: ${props => props.fontSize || ""};
`;

export const Textarea = styled(TextareaAutosize)`
 
  width: 100%;
  outline: none;
  text-align: ${props => props.padding || "left"};
  border: 1px solid #c8c8c8;
  font-size: 1.3rem;
  padding: ${props => props.padding || "8px"};
  margin: ${props => props.margin || "0"};
  resize: none;
  font-weight: bold;
  border-bottom: 1px solid black;
  :focus {
    border: 2px solid var(--plsGreen);
  }
`;


export const Button = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  background-color: var(--plsGreen);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  :hover {
    background-color: darkgreen;
  }
`;

const POForm = ({ setPoInfo }) => {
  const [formData, setFormData] = useState({
    dateDue: new Date(),
    poNumber: "",
    jobNumber: "",
    quoteNumber: "",
    vendor: "",
    contact: "",
    notes: "Please return proofs and 25 samples with the job",
     initials:"JW 1582",
    checkboxes: {
      poEnclosed: false,
      proofsEnclosed: false,
      samplesEnclosed: false,
      diesProvided: false,
      pressCheckRequired: false,
     
    },
  });

  const handleInputChange = (e) => {
 const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

    const handleDateChange = (date) => {

    setFormData({ ...formData,'dateDue': date });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      checkboxes: { ...formData.checkboxes, [name]: checked },
    });
  };

  const handleSubmit = () => {
    setPoInfo({
      ...formData,
      items: [], // Placeholder; add item inputs if needed
    });
  };

  return (
    <Wrapper>
      <Flexed>
        <Flex style={{ display: "flex", flexDirection: "column", gap:'7px' }}>
          <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.3rem" padding="5px 0">
            <input
              type="checkbox"
              name="poEnclosed"
              checked={formData.checkboxes.poEnclosed}
              onChange={handleCheckboxChange}
              style={{ width: "1rem", height: "1rem", marginRight: "8px" }}
            />
            <span style={{ fontSize: '1.3rem' }}>P.O. Enclosed</span>
          </Flexed>
          <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.3rem" padding="5px 0">
            <input
              type="checkbox"
              name="proofsEnclosed"
              checked={formData.checkboxes.proofsEnclosed}
              onChange={handleCheckboxChange}
              style={{ width: "1rem", height: "1rem", marginRight: "8px" }}
            />
            <span style={{ fontSize: '1.3rem' }}>Proof's Enclosed</span>
          </Flexed>
          <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.3rem" padding="5px 0">
            <input
              type="checkbox"
              name="samplesEnclosed"
              checked={formData.checkboxes.samplesEnclosed}
              onChange={handleCheckboxChange}
              style={{ width: "1rem", height: "1rem", marginRight: "8px" }}
            />
            <span style={{ fontSize: '1.3rem' }}>Samples Enclosed</span>
          </Flexed>
          <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.3rem" padding="5px 0">
            <input
              type="checkbox"
              name="diesProvided"
              checked={formData.checkboxes.diesProvided}
              onChange={handleCheckboxChange}
              style={{ width: "1rem", height: "1rem", marginRight: "8px" }}
            />
            <span style={{ fontSize: '1.3rem' }}>Die(s) Provided / to be made</span>
          </Flexed>
          <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.3rem" padding="5px 0">
            <input
              type="checkbox"
              name="pressCheckRequired"
              checked={formData.checkboxes.pressCheckRequired}
              onChange={handleCheckboxChange}
              style={{ width: "1rem", height: "1rem", marginRight: "8px" }}
            />
            <span style={{ fontSize: '1.3rem' }}>Press Check Required</span>
          </Flexed>
             <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.3rem" padding="5px 0">
          
            <span style={{ fontSize: '1.3rem' }}>Items Enclosed are Accurate</span>
               <Input
                name="initials"
                value={formData.initials}
                onChange={handleInputChange}
                fontSize="1.3rem"
              />
          </Flexed>
        </Flex>

        <Flex >
          <Flexed style={{marginBottom:'5px'}}>
            <Flex fontSize="1.3rem" textAlign="right" style={{ paddingRight: "10px" }}>
              Date Due Back To PLS Print:
            </Flex>
            <Flex>
             <Datepick name="dateDue" selected={formData.dateDue}   onChange={(date => handleDateChange(date))} />
            </Flex>
          </Flexed>
          <Flexed style={{marginBottom:'5px'}}>
            <Flex fontSize="1.3rem" textAlign="right" style={{ paddingRight: "10px" }}>
              PO #:
            </Flex>
            <Flex>
              <Input
                name="poNumber"
                value={formData.poNumber}
                onChange={handleInputChange}
                fontSize="1.3rem"
              />
            </Flex>
          </Flexed>
          <Flexed style={{marginBottom:'5px'}}>
            <Flex fontSize="1.3rem" textAlign="right" style={{ paddingRight: "10px" }}>
              PLS Print Job#:
            </Flex>
            <Flex>
              <Input
                name="jobNumber"
                value={formData.jobNumber}
                onChange={handleInputChange}
                fontSize="1.3rem"
              />
            </Flex>
          </Flexed>
          <Flexed style={{marginBottom:'5px'}}>
            <Flex fontSize="1.3rem" textAlign="right" style={{ paddingRight: "10px" }}>
              Quote#:
            </Flex>
            <Flex>
              <Input
                name="quoteNumber"
                value={formData.quoteNumber}
                onChange={handleInputChange}
                fontSize="1.3rem"
              />
            </Flex>
          </Flexed>
          <Flexed style={{marginBottom:'5px'}}>
            <Flex fontSize="1.3rem" textAlign="right" style={{ paddingRight: "10px" }}>
              Outside Service Vendor:
            </Flex>
            <Flex>
              <Input
                name="vendor"
                value={formData.vendor}
                onChange={handleInputChange}
                fontSize="1.3rem"
              />
            </Flex>
          </Flexed>
          <Flexed style={{marginBottom:'5px'}}>
            <Flex fontSize="1.3rem" textAlign="right" style={{ paddingRight: "10px" }}>
              Contact:
            </Flex>
            <Flex>
              <Input
                name="contact"
                value={formData.contact}
                onChange={handleInputChange}
                fontSize="1.3rem"
              />
            </Flex>
          </Flexed>
        </Flex>
      </Flexed>



      <Flexed style={{ marginTop: '20px' }}>
        <Flex>
          <div style={{ fontSize: "1.5rem" }}>* Notes *</div>
          <div style={{ width: '100%' }}>
            <Textarea
             minRows={8}
              textAlign='left'
               maxRows={8}
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
            
            />
          </div>
        </Flex>
      </Flexed>

     
      {formData && <PrintComponent formData={formData}  />}
    </Wrapper>
  );
};

// Parent component to integrate POForm and PrintComponent
const OutsideServiceForm = () => {
  const [poInfo, setPoInfo] = useState(null);

  const savePo = () => {
    // Placeholder for savepo functionality
    console.log("Saving PO:", poInfo);
  };

  return (
    <div>
      <POForm setPoInfo={setPoInfo} />
      
    </div>
  );
};

export default OutsideServiceForm;